import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useController } from 'react-hook-form';

const ControlledCheckBoxRadio = (props) => {
  const { items, label, name, disabled = false } = props;

  const { field } = useController({
    name,
    defaultValue: '', // Set default value as an empty string or null
  });

  const handleChange = (event) => {
    const newValue = event.target.value;
    // If the checkbox is already selected, uncheck it
    if (field.value === newValue) {
      field.onChange(''); // Reset to empty string
    } else {
      field.onChange(newValue); // Set the value of the selected checkbox
    }
  };

  return (
    <Box sx={{ mt: -1.5 }}>
      <Typography variant='caption' gutterBottom sx={{ lineHeight: 1, color: 'rgba(0, 0, 0, 0.6)' }}>
        {label}
      </Typography>
      <Box>
        {items.map((c) => (
          <FormControlLabel
            key={c.value}
            sx={{
              alignItems: 'flex-start',
              '& .MuiCheckbox-root': {
                pt: 0,
              },
              '&.Mui-disabled': {
                color: (thm) => `${thm.palette.text.disabled} !important`,
                cursor: disabled ? 'not-allowed' : 'inherit',
              },
            }}
            name={name}
            disableTypography
            control={
              <Checkbox
                checked={field.value === c.value} // Only one checkbox can be selected
                onChange={handleChange}
                value={c.value}
                disabled={disabled || !!(field.value && field.value !== c.value)} // Disable other checkboxes
              />
            }
            label={
              <Box component='span' sx={{ color: (thm) => (field.value && field.value !== c.value ? thm.palette.grey[500] : 'inherit') }}>
                {c.label}
              </Box>
            }
          />
        ))}
      </Box>
    </Box>
  );
};

export default ControlledCheckBoxRadio;
